"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../ThemeProvider");
var _LinkBase = _interopRequireDefault(require("./LinkBase"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * `TextButton` is a button that looks like a Link. It uses the same theming and variants as
 * Link but has the accessibility role of a `Button`. It should be used for actions that
 * take place on the current page, or for navigation within an app.
 */const TextButton = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    onPress,
    children,
    variant,
    tokens,
    accessibilityRole = 'button',
    ...linkProps
  } = _ref;
  const getTokens = (0, _ThemeProvider.useThemeTokensCallback)('Link', tokens, variant);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinkBase.default, {
    onPress: onPress,
    accessibilityRole: accessibilityRole,
    tokens: getTokens,
    ref: ref,
    ...linkProps,
    children: children
  });
});
TextButton.displayName = 'TextButton';
TextButton.propTypes = {
  ..._LinkBase.default.propTypes,
  /** onPress function */
  onPress: _propTypes.default.func.isRequired,
  /** Children node that can be added */
  children: _propTypes.default.node.isRequired,
  variant: _utils.variantProp.propType,
  /** Accesibility role for TextButton */
  accessibilityRole: _propTypes.default.string
};
var _default = exports.default = TextButton;